import React, { useState, useEffect, useContext } from 'react';
import { useDataHelper } from 'utils/dataHelper';
import { useNetwork } from 'services/network';
import { SdmTypography, SdmImage } from 'components';
import { styled } from '@material-ui/core/styles';
import { Card } from '@material-ui/core';
import {
  StatusRadio,
  SelectCardRadio,
} from 'pages/exhibitor/exhibitorBookmarks/components';
import { ExhibitorContext } from 'context/ExhibitorContextProvider';
import MapOutlinedIcon from '@material-ui/icons/MapOutlined';
import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined';
import translations from 'utils/translations';
import { useIntl } from 'react-intl';
import { theme } from 'theme';
import { backHomeLink, isMapBrandActive } from 'utils/constants';

const CardContainer = styled(Card)({
  maxWidth: '300px',
  minHeight: 376,
  padding: 24,
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  cursor: 'pointer',
});

const CardBody = styled('div')({});

const CardFooter = styled('div')({
  borderTop: '1px solid rgba(0, 0, 0, 0.3)',
  paddingTop: 16,
});

const MapLabelContainer = styled('div')({
  width: '85%',
  height: 32,
  padding: '5px 15px',
  position: 'absolute',
  bottom: 0,
  left: 24,
  backgroundColor: '#F3F3F3',
});

export const ExhibitorCard = ({
  exhibitor,
  onExhibitorSelected,
  locale,
  isExhibitorManage = false,
  showRadioSelect = false,
  onCardSelected = () => {},
}) => {
  //Hooks
  const { ellips } = useDataHelper();
  const intl = useIntl();
  const i18n = translations.exhibitorBookmark(intl);
  const networkHelper = useNetwork();
  const { incognitoMode } = useContext(ExhibitorContext);
  //States
  const [fetchedSrcLogoUrl, setFetchedSrcLogoUrl] = useState();

  //Effects
  useEffect(() => {
    if (exhibitor) {
      fetchLogo();
    }
  }, [exhibitor]);

  //Functions
  const onExhibitorSelection = () => {
    onExhibitorSelected && onExhibitorSelected(exhibitor);
  };

  const fetchLogo = async () => {
    if (exhibitor.salesforceId) {
      const url = await networkHelper.getExhibitorLogoUrl(
        exhibitor?.salesforceId
      );
      setFetchedSrcLogoUrl(url);
    } else {
      setFetchedSrcLogoUrl(null);
    }
  };

  const handleSeeOnMap = () =>
    (window.location.href = `${backHomeLink}/${locale}/map?poi=${exhibitor?.hall}${exhibitor?.salesforceId}`);

  return (
    <CardContainer
      elevation={3}
      onClick={onExhibitorSelection}
      style={{ position: 'relative' }}
    >
      {exhibitor.salesforceId && !incognitoMode && exhibitor?.hall ? (
        <StatusRadio
          exhibitor={exhibitor}
          isExhibitorManage={isExhibitorManage}
        />
      ) : null}
      {showRadioSelect && !incognitoMode ? (
        <SelectCardRadio
          id={exhibitor.salesforceId}
          onChecked={onCardSelected}
        />
      ) : null}
      <CardBody>
        <SdmImage url={fetchedSrcLogoUrl} />

        <div style={{ marginTop: 20 }}>
          <SdmTypography
            variant={'h5Regular'}
            style={{ textTransform: 'uppercase' }}
          >
            {exhibitor.nation}
          </SdmTypography>
          <SdmTypography variant={'h2Regular'}>
            {ellips(exhibitor.name, 39)}
          </SdmTypography>
        </div>
      </CardBody>
      <CardFooter>
        <SdmTypography
          style={{
            whiteSpace: ' nowrap',
            overflow: ' hidden',
            textOverflow: 'ellipsis',
          }}
          variant={'text'}
        >
          {exhibitor.event}
        </SdmTypography>
        <SdmTypography
          variant={'text'}
          style={{
            whiteSpace: ' nowrap',
            overflow: ' hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {exhibitor.hall} {exhibitor.hall && exhibitor.stand ? '-' : ''}{' '}
          {exhibitor.stand}
        </SdmTypography>
      </CardFooter>
      {exhibitor?.hall && exhibitor?.salesforceId && isMapBrandActive ? (
        <MapLabelContainer>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 15,
              cursor: 'pointer',
            }}
            onClick={(e) => {
              e.stopPropagation();
              handleSeeOnMap();
            }}
          >
            <MapOutlinedIcon style={{ color: theme.colors.primary.red }} />
            <SdmTypography
              variant={'body1'}
              margin={0}
              style={{ fontSize: 12, color: theme.colors.primary.red }}
            >
              {i18n.labels.seeOnMap}
            </SdmTypography>
            <ArrowForwardOutlinedIcon
              style={{ color: theme.colors.primary.red }}
            />
          </div>
        </MapLabelContainer>
      ) : null}
    </CardContainer>
  );
};
